import styled from 'styled-components';

export const IconWrapper = styled.i`
  font-size: 1rem;
  margin-right: 0.5rem;
`;

type Props = {
  loading?: boolean;
  maxWidth?: string;
  width?: string;
};

export const ActionButton = styled.button<Props>`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: ${props => props.theme.uiColors.multiFlightMapBackgroundColor};
  box-shadow: 0px 0px 12px 0px ${props => props.theme.uiColors.multiFlightMapActionButtonShadowColor};
  border: 1px solid ${props => props.theme.uiColors.multiFlightMapBackgroundColor};
  height: 36px;
  color: ${props => props.theme.uiColors.multiFlightMapSecondaryColor};
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  ${props => (props.maxWidth ? `max-width: ${props.maxWidth}` : `width: ${props.width || '138px'}`)};
  outline-color: ${props => props.theme.uiColors.multiFlightMapBackgroundColor};

  span {
    font-family: ${props => props.theme.fontRegular};
    font-size: ${props => props.theme.fontSizeS};
  }
   ${props =>
     props.loading &&
     `
        box-sizing: border-box;
        color: ${props.theme.uiColors.multiflightMapAdvancedSettingsVenuesDisabled};
        cursor: default;
        pointer-events: none;
      `};

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  &:hover {
    color: ${props => props.theme.uiColors.multiFlightMapPrimaryColor};
  }
`;
